module.exports = __webpack_public_path__ + "img/useFlow-small-start.dd9f02e.png";